query intervals($filter: IntervalFilterInput, $scenarioId: ID!) {
  data(scenarioId: $scenarioId) {
    intervals(filter: $filter) {
      items {
        id
        startingDate
        endingDate
        usableInBookings
      }
      __typename
    }
    __typename
  }
}
